module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAA+0lEQVQoU43QIUsEURQF4HPez5j/YBS870UxabBsEBHWtEmD2EwKYhBBrGuyGEZNBsGiOO+9PmibZBs2WMZgcK48GWV1F/HGy/0Oh0sRuSR5E0IY4h/jnFtt27ZPa+2Wqh4aYwbe+9O/rIgsk8wB7DMdWmt3VHUPwHqM8WwaFpF5ktcAhiGEzU+YRkR2SaaAtRjj+Th2zs2p6i3JK+99H4B+w3TonDtQ1W0AKyGEiy5whuQdyfssy3p5nr+n/Q/Y1T4CsAGgp6pPAB6MMY91XS9VVfX21WQCdvhEVQckRwCem6ZZKMvydbz+VJiaWGuPAcwaYxaLonj5/bAPHzZfnWDaF0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/down.png
// module id = yGdi
// module chunks = 1